// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_3kAJ8","icon":"_2HydQ","disappear":"_2UO6q","rotating":"_1HGNE"};